import { TimeFormats } from '../../../DateTime/types'
import { getDatePickerValues } from '../../../../inputs/DateTimePicker/getDatePickerValues'
import { PeriodPicker } from '../../../../inputs/PeriodPicker/PeriodPicker'
import { transformDate } from '../../../DateTime/utils'
import styles from '../../Styles/index.module.scss'
import AppButton from '../../../../buttons/AppButton/AppButton'
import { FROM, TimePeriod, TO } from './lib/PluginSchedule'
import { PATH_JOINER } from '../../../utils/getConfigBitPath'

interface ScheduleTimePeriodProps {
    index: number
    dataPath: string[]
    timePeriod: TimePeriod
    timePeriods: Array<TimePeriod>
    onStartTimeChange: (path: string[], time: string) => void
    onEndTimeChange: (path: string[], time: string | null) => void
    onTimeDelete: (path: string[], data: TimePeriod[], errorKeyName: string) => void
}

export const ScheduleTimePeriod = (props: ScheduleTimePeriodProps) => {
    const {
        index,
        dataPath,
        timePeriod,
        timePeriods,
        onStartTimeChange,
        onEndTimeChange,
        onTimeDelete
    } = props

    const path = [...dataPath, index] as unknown as string[]
    const errorKeyName = path.join(PATH_JOINER)

    const dateFrom = getDatePickerValues(
        TimeFormats.HOURS_MINUTES_SECONDS,
        { [FROM]: timePeriod.from },
        FROM
    ).selected

    const dateTo = getDatePickerValues(
        TimeFormats.HOURS_MINUTES_SECONDS,
        { [TO]: timePeriod.to },
        TO
    ).selected

    const handleStartTimeChange = (date: Date | null) => {
        const timeFromFormatted =
            transformDate(
                TimeFormats.HOURS_MINUTES_SECONDS,
                date,
                TimeFormats.HOURS_MINUTES_SECONDS
            ) ?? ''

        onStartTimeChange([...path, FROM], timeFromFormatted)
    }

    const handleEndTimeChange = (date: Date | null) => {
        const timeToFormatted = date
            ? transformDate(
                  TimeFormats.HOURS_MINUTES_SECONDS,
                  date,
                  TimeFormats.HOURS_MINUTES_SECONDS
              )
            : null
        onEndTimeChange([...path, TO], timeToFormatted)
    }

    const handleDelete = () => {
        const filteredTimePeriods = timePeriods.filter(
            (periodItem) => periodItem.element_id !== timePeriod.element_id
        )
        onTimeDelete(dataPath, filteredTimePeriods, errorKeyName)
    }

    return (
        <div className="p-relative">
            <PeriodPicker
                periodType="time"
                className={styles.periodPicker}
                containerClassName={styles.container}
                dateFrom={dateFrom}
                dateTo={dateTo}
                onDateFromChange={handleStartTimeChange}
                onDateToChange={handleEndTimeChange}
            />
            <AppButton
                variant="close"
                tooltip="Delete time period"
                onClick={handleDelete}
                className="position-absolute bottom-0 right-0 mb-1 me-1"
            />
        </div>
    )
}
